/* eslint-disable @typescript-eslint/no-var-requires */
import { Tabs } from 'antd';
import TabPane from 'antd/lib/tabs/TabPane';
import React, { useState } from 'react';
import './animation042.less';
import AnswerCover from '../../components/answerCover';

import ImgPoint from '../../../../../assets/animation_point.gif';
import ImgPlus from '../../../../../assets/plus.png';

interface IAnimation042Props {
  alert?: string;
  tip?: string;
  tabName1: string;
  tabName2: string;
  tabName3: string;
  tabName4: string;
  panel1: string;
  panel2: string;
  panel3: string;
  panel4: string;
  panel5: string;
  panel6: string;
  panel7: string;
  panel8: string;
  panel9: string;
  panel10: string;
  panel11: string;
  panel12: string;
  panel13: string;
  panel14: string;
  panel15: string;
  panel16: string;
  highlight1: string;
  highlight2: string;
  highlight3: string;
  highlight4: string;
  highlight5: string;
  highlight6: string;
  highlight7: string;
  highlight8: string;
  className: string;
  onCompleted?: () => void;
}

const Animation042: React.FunctionComponent<IAnimation042Props> = ({
  alert,
  tip,
  tabName1,
  tabName2,
  tabName3,
  tabName4,
  panel1,
  panel2,
  panel3,
  panel4,
  panel5,
  panel6,
  panel7,
  panel8,
  panel9,
  panel10,
  panel11,
  panel12,
  panel13,
  panel14,
  panel15,
  panel16,
  highlight1,
  highlight2,
  highlight3,
  highlight4,
  highlight5,
  highlight6,
  highlight7,
  highlight8,
  className,
  onCompleted,
}) => {
  const [state, setState] = React.useState({
    conversation: 0,
    animationPassword: false,
    coveredAnswer: 4,
  });
  const [tabValue, setTabValue] = useState('1');
  const [tabStatus, setTabStatus] = useState<number[]>([]);
  const handleCoverChange = (idx: number) => {
    setTabStatus([...tabStatus, idx]);
  };
  const checkTabIndicateHide = (index: number) =>
    !(
      Boolean(tabStatus.find((itm) => itm.toString() === tabValue)) &&
      Math.min(...[1, 2, 3, 4].filter((itm) => !tabStatus.includes(itm))) ===
        index
    );
  const revealAnswer = () => {
    setState({
      ...state,
      coveredAnswer: state.coveredAnswer - 1,
    });
    console.log(state.coveredAnswer);
    if (state.coveredAnswer <= 1) {
      console.log('completed');
      onCompleted && onCompleted();
    }
  };

  return (
    <div className={`topic-tab-section component ${className}`}>
      {alert && (
        <div className="warning-alert">
          <span dangerouslySetInnerHTML={{ __html: alert }} />
        </div>
      )}
      {tip && (
        <div className="tips" dangerouslySetInnerHTML={{ __html: tip }} />
      )}
      <Tabs
        type="card"
        className={`topic-tab tab${tabValue}`}
        onChange={(activeKey) => setTabValue(activeKey)}
      >
        <TabPane
          tab={
            <>
              {tabName1}
              <img
                className="click-point-tab"
                hidden={checkTabIndicateHide(1)}
                src={ImgPoint}
                alt=""
              />
            </>
          }
          key="1"
        >
          <div className="panel">
            <div className="l1">{panel1}</div>
            <div className="l2">{panel2}</div>
          </div>
          <img src={ImgPlus} alt="" />
          <div className="panel">
            <div className="l1">{panel3}</div>
            <div className="l2">{panel4}</div>
          </div>
          <AnswerCover
            onChange={revealAnswer}
            onCoverChange={() => handleCoverChange(1)}
          >
            <div className="highlight-panel panel">
              <div className="l1">{highlight1}</div>
              <div
                className="l2"
                dangerouslySetInnerHTML={{
                  __html: highlight2,
                }}
              />
            </div>
          </AnswerCover>
        </TabPane>
        <TabPane
          tab={
            <>
              {tabName2}
              <img
                className="click-point-tab"
                hidden={checkTabIndicateHide(2)}
                src={ImgPoint}
                alt=""
              />
            </>
          }
          key="2"
        >
          <div className="panel">
            <div className="l1">{panel5}</div>
            <div
              className="l2"
              dangerouslySetInnerHTML={{
                __html: panel6,
              }}
            />
          </div>
          <img src={ImgPlus} alt="" />
          <div className="panel">
            <div className="l1">{panel7}</div>
            <div className="l2">{panel8}</div>
          </div>
          <AnswerCover
            onChange={revealAnswer}
            onCoverChange={() => handleCoverChange(2)}
          >
            <div className="highlight-panel panel">
              <div className="l1">{highlight3}</div>
              <div
                className="l2"
                dangerouslySetInnerHTML={{
                  __html: highlight4,
                }}
              />
            </div>
          </AnswerCover>
        </TabPane>
        <TabPane
          tab={
            <>
              {tabName3}
              <img
                className="click-point-tab"
                hidden={checkTabIndicateHide(3)}
                src={ImgPoint}
                alt=""
              />
            </>
          }
          key="3"
        >
          <div className="panel">
            <div className="l1">{panel9}</div>
            <div className="l2">{panel10}</div>
          </div>
          <img src={ImgPlus} alt="" />
          <div className="panel">
            <div className="l1">{panel11}</div>
            <div
              className="l3"
              dangerouslySetInnerHTML={{
                __html: panel12,
              }}
            />
          </div>
          <AnswerCover
            onChange={revealAnswer}
            onCoverChange={() => handleCoverChange(3)}
          >
            <div className="highlight-panel panel">
              <div className="l1">{highlight5}</div>
              <div
                className="l2"
                dangerouslySetInnerHTML={{
                  __html: highlight6,
                }}
              />
            </div>
          </AnswerCover>
        </TabPane>
        <TabPane
          tab={
            <>
              {tabName4}
              <img
                className="click-point-tab"
                hidden={checkTabIndicateHide(4)}
                src={ImgPoint}
                alt=""
              />
            </>
          }
          key="4"
        >
          <div className="panel">
            <div className="l1">{panel13}</div>
            <div className="l2">{panel14}</div>
          </div>
          <img src={ImgPlus} alt="" />
          <div className="panel">
            <div className="l1">{panel15}</div>
            <div
              className="l4"
              dangerouslySetInnerHTML={{
                __html: panel16,
              }}
            />
          </div>
          <AnswerCover
            onChange={revealAnswer}
            onCoverChange={() => handleCoverChange(4)}
          >
            <div className="highlight-panel panel">
              <div className="l1">{highlight7}</div>
              <div
                className="l2"
                dangerouslySetInnerHTML={{
                  __html: highlight8,
                }}
              />
            </div>
          </AnswerCover>
        </TabPane>
      </Tabs>
    </div>
  );
};

export default Animation042;
